<template>
	<div class="span">
		<!--prices banner-->
		<section class="prices_banner marginTop_fixed">
			<div class="container eight50">
				<div class="row align-items-center">
					<div class="col-md-6">
						<h1>
							<span>Plans & <br />Prices</span>
						</h1>
					</div>
					<div class="col-md-6">
						<svg
							width="301"
							height="183"
							viewBox="0 0 301 183"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M113.707 8.93967C122.23 13.2484 128.265 17.655 131 20.1444C131.234 20.3567 131.416 20.6187 131.535 20.911C132.957 24.4107 134.381 28.5326 135.683 33.1301H149.715C138.416 20.5541 125.415 13.1144 113.707 8.93967ZM153.286 37.3528H136.808C138.054 42.3368 139.136 47.7831 139.918 53.5363C143.538 54.3255 148.501 55.4327 153.126 56.5168C156.491 57.3055 159.748 58.0978 162.175 58.752C161.42 53.0762 159.835 47.8229 157.254 43.1591C156.395 41.6065 155.425 40.1171 154.336 38.6969C153.988 38.2432 153.638 37.7952 153.286 37.3528ZM162.598 63.2533C160.35 62.5968 156.461 61.6356 152.163 60.6281C148.148 59.687 143.872 58.7274 140.453 57.9762C140.951 62.7133 141.233 67.6266 141.228 72.6349C144.667 73.1583 149.219 73.8155 153.411 74.3472C155.9 74.6629 158.246 74.9323 160.151 75.1035C160.986 75.1785 161.7 75.231 162.288 75.2626C162.698 71.1422 162.819 67.1211 162.598 63.2533ZM161.775 79.4634C161.151 79.426 160.475 79.3724 159.773 79.3093C157.795 79.1315 155.391 78.855 152.88 78.5364C148.87 78.0279 144.544 77.407 141.154 76.8947C141.035 80.3942 140.768 83.9297 140.33 87.4739C143.747 88.7283 148.232 90.3603 152.141 91.752C154.417 92.5622 156.488 93.2876 158.038 93.8091C158.281 93.8909 158.51 93.9673 158.724 94.0378C158.879 93.4609 159.031 92.8841 159.178 92.3075C160.283 87.9925 161.168 83.6915 161.775 79.4634ZM157.568 98.1029C157.295 98.0134 157.002 97.9158 156.691 97.8112C155.106 97.2779 153.008 96.5428 150.725 95.7302C147.114 94.4445 143.018 92.9563 139.718 91.7472C138.836 97.1452 137.534 102.541 135.727 107.837L152.153 113.546C154.169 108.497 156.009 103.314 157.568 98.1029ZM150.545 117.457L134.27 111.801C132.71 115.757 130.849 119.641 128.651 123.412C131.649 124.954 135.438 126.755 138.794 128.047C140.883 128.852 142.69 129.414 143.992 129.626C144.414 129.695 144.721 129.716 144.931 129.715C145.407 128.749 145.881 127.772 146.352 126.784C147.663 124.031 148.948 121.198 150.184 118.306C150.305 118.024 150.425 117.741 150.545 117.457ZM142.908 133.722C141.248 133.404 139.277 132.758 137.276 131.988C133.628 130.583 129.557 128.636 126.424 127.015C124.231 130.363 121.753 133.605 118.963 136.708C122.035 138.93 125.936 141.645 129.367 143.814C131.475 145.146 133.341 146.231 134.706 146.874C134.971 146.999 135.201 147.099 135.396 147.178C137.445 143.783 139.576 140.037 141.703 136.024C142.105 135.266 142.507 134.499 142.908 133.722ZM136.129 147.417C136.138 147.418 136.141 147.418 136.14 147.418C136.14 147.418 136.136 147.418 136.129 147.417ZM133.153 150.808C133.07 150.771 132.988 150.732 132.905 150.694C131.298 149.936 129.255 148.738 127.111 147.383C123.411 145.044 119.215 142.112 116.032 139.799C114.971 140.861 113.87 141.905 112.728 142.928C110.87 144.592 109.01 146.152 107.151 147.611C107.7 148.183 108.401 148.835 109.226 149.54C110.96 151.025 113.156 152.676 115.426 154.22C117.697 155.764 120.001 157.173 121.947 158.185C122.923 158.692 123.776 159.083 124.47 159.342C124.712 159.432 124.916 159.499 125.084 159.548C126.161 158.647 127.179 157.744 128.133 156.847C129.305 155.745 130.381 154.654 131.356 153.589C131.942 152.701 132.542 151.773 133.153 150.808ZM121.245 162.551C120.839 162.359 120.423 162.152 119.999 161.932C117.866 160.822 115.417 159.321 113.051 157.712C110.684 156.102 108.359 154.357 106.479 152.748C105.54 151.944 104.691 151.156 103.996 150.422C103.916 150.337 103.837 150.251 103.758 150.165C98.9902 153.604 94.239 156.4 89.547 158.638L108.872 169.966C113.454 167.763 117.605 165.215 121.245 162.551ZM104.1 172.064L84.7735 160.735C79.1233 163.006 73.5909 164.49 68.2551 165.343L89.5656 176.199C94.716 175.308 99.5811 173.87 104.1 172.064ZM81.993 177.08L60.5578 166.161C50.7537 166.681 41.82 165.171 34.2947 162.737C51.3871 174.359 67.6566 177.943 81.993 177.08ZM19.5767 150.801C7.26198 135.425 -9.32088 93.8613 23.1233 49.773C49.4454 14.004 72.6263 4.83461 85.479 4.33556C88.7613 4.20811 91.324 4.64516 93.0936 5.29868C93.1382 5.31512 93.1832 5.33005 93.2287 5.34345C110.811 10.5205 123.426 19.1185 127.805 22.9529C129.257 26.5821 130.72 30.9202 132.038 35.793C133.64 41.7101 135.024 48.3999 135.922 55.5475C136.68 61.579 137.089 67.9295 136.991 74.4115C136.921 79.0927 136.585 83.8394 135.926 88.582C134.996 95.267 133.424 101.938 131.045 108.405C129.183 113.468 126.826 118.405 123.896 123.127C121.198 127.473 118.013 131.639 114.274 135.555C112.896 136.999 111.443 138.409 109.91 139.782C107.574 141.875 105.24 143.791 102.914 145.542C96.5577 150.327 90.2585 153.88 84.1274 156.437C76.022 159.817 68.1901 161.467 60.879 161.913C42.5388 163.031 27.4363 156.576 19.5767 150.801ZM153.33 121.67C152.635 123.26 151.927 124.831 151.209 126.378C186.584 136.946 213.168 139.104 232.02 137.527C243.158 136.595 251.522 134.369 257.407 131.851C252.909 132.481 248.256 132.891 243.514 133.113C237.411 133.4 231.153 133.377 224.878 133.114C218.155 132.832 211.408 132.275 204.808 131.525C196.787 130.614 188.977 129.419 181.682 128.088C176.507 127.143 171.59 126.13 167.038 125.101C161.968 123.954 157.349 122.786 153.33 121.67ZM269.064 129.602C263.679 134.677 251.655 140.122 232.372 141.735C212.774 143.375 185.452 141.082 149.377 130.237C149.077 130.854 148.777 131.466 148.475 132.073C148.471 132.082 148.467 132.09 148.463 132.098C147.782 133.471 147.096 134.821 146.409 136.145C148.324 137.136 150.503 138.149 152.931 139.151C156.324 140.551 160.194 141.926 164.492 143.192C169.836 144.766 175.837 146.17 182.401 147.241C187.274 148.036 192.456 148.648 197.908 149.012C204.02 149.419 210.471 149.514 217.208 149.204C221.872 148.99 226.672 148.582 231.592 147.949C236.773 147.282 242.085 146.367 247.509 145.167C253.966 143.739 260.581 141.907 267.319 139.611C271.284 138.26 275.292 136.749 279.336 135.064C283.087 133.502 286.869 131.79 290.677 129.919C290.219 126.638 289.639 123.523 289.041 120.81C287.686 121.989 286.375 122.901 285.247 123.532C285.235 123.539 285.223 123.546 285.211 123.552C283.853 124.278 282.448 124.955 281.002 125.587C280.997 125.589 280.992 125.591 280.986 125.593C277.27 127.215 273.271 128.538 269.064 129.602ZM283.626 119.589C285.027 118.731 286.857 117.285 288.634 115.27C291.537 111.979 294.212 107.281 294.745 101.294C292.529 102.627 289.668 103.62 286.1 104.221C285.647 107.583 285.005 111.977 284.341 115.786C284.106 117.14 283.865 118.434 283.626 119.589ZM281.769 104.731C278.509 104.969 274.741 104.954 270.402 104.642C269.303 104.563 268.223 104.494 267.16 104.433C267.119 108.093 266.975 112.854 266.657 117.27C266.464 119.956 266.203 122.552 265.853 124.708C265.776 125.184 265.694 125.645 265.605 126.086C266.241 125.944 266.871 125.795 267.495 125.642C271.478 124.66 275.226 123.45 278.684 121.987C278.795 121.663 278.926 121.201 279.074 120.599C279.42 119.191 279.8 117.248 280.181 115.061C280.765 111.712 281.335 107.882 281.769 104.731ZM261.028 127.003C261.073 126.865 261.12 126.709 261.168 126.532C261.351 125.865 261.524 125.024 261.685 124.033C262.006 122.051 262.256 119.595 262.445 116.966C262.761 112.591 262.901 107.845 262.94 104.231C258.275 104.052 253.927 104.032 249.776 104.095L245.905 128.754C251.136 128.428 256.207 127.858 261.028 127.003ZM241.597 128.967L245.487 104.189C242.268 104.279 239.162 104.405 236.086 104.53C234.499 104.594 232.92 104.658 231.337 104.717L227.43 128.983C232.207 129.135 236.95 129.14 241.597 128.967ZM223.181 128.809L227.038 104.858C222.525 104.984 217.963 105.024 213.172 104.853C212.404 108.941 211.328 114.358 210.26 119.127C209.644 121.877 209.025 124.442 208.462 126.42C208.341 126.848 208.22 127.255 208.1 127.636C213.09 128.157 218.142 128.56 223.181 128.809ZM203.811 127.159C203.986 126.662 204.184 126.027 204.401 125.265C204.93 123.402 205.53 120.928 206.14 118.204C207.145 113.714 208.161 108.626 208.914 104.647C203.804 104.333 198.399 103.755 192.491 102.779C192.255 106.696 191.676 111.696 190.571 116.159C189.898 118.877 189.001 121.513 187.797 123.605C187.574 123.994 187.331 124.377 187.069 124.747C192.456 125.658 198.075 126.48 203.811 127.159ZM181.942 123.842C182.572 123.578 183.331 122.9 184.138 121.498C185.061 119.893 185.842 117.686 186.472 115.144C187.547 110.804 188.1 105.83 188.304 102.034C184.38 101.289 180.235 100.368 175.814 99.2387L170.093 121.455C173.833 122.276 177.802 123.081 181.942 123.842ZM165.972 120.524L171.731 98.1572C168.841 97.3646 165.835 96.4851 162.7 95.5099C162.543 96.0869 162.382 96.6637 162.218 97.24C160.31 103.946 157.935 110.603 155.309 117.001C155.207 117.251 155.104 117.501 155 117.751C158.282 118.654 161.967 119.592 165.972 120.524ZM163.752 91.4147C167.646 92.6292 171.333 93.6921 174.838 94.6212C180.634 96.1576 185.934 97.3282 190.862 98.2127C198.479 99.5798 205.217 100.266 211.529 100.56C217.756 100.849 223.58 100.758 229.457 100.559C231.566 100.487 233.693 100.4 235.849 100.313C239.752 100.154 243.753 99.9921 247.921 99.9052C253.26 99.7938 258.926 99.8041 265.162 100.1C266.96 100.185 268.806 100.294 270.704 100.43C276.105 100.818 280.462 100.719 283.947 100.272C290.437 99.4387 293.65 97.4386 295.141 95.4113C296.368 93.7423 296.663 91.7418 296.29 89.577C295.924 87.4579 294.93 85.3017 293.714 83.4906C245.042 38.4492 187.311 37.8856 162.195 43.5519C163.042 45.3531 163.764 47.2144 164.37 49.1266C167.701 48.2627 171.851 47.9562 176.482 48.0538C181.675 48.1631 187.614 48.785 193.934 49.7967C206.575 51.8202 220.875 55.4249 234.021 59.7314C247.146 64.0308 259.242 69.0691 267.424 73.9998C271.483 76.446 274.772 78.9783 276.691 81.5201C277.66 82.8034 278.379 84.2186 278.563 85.7317C278.755 87.3125 278.339 88.8201 277.35 90.1393C275.835 92.1605 273.23 93.3796 270.291 94.1531C267.284 94.9445 263.555 95.3642 259.351 95.5097C250.933 95.801 240.261 95.0021 228.894 93.6053C207.119 90.9295 182.502 86.0215 165.639 82.1256C165.137 85.2081 164.5 88.3116 163.752 91.4147ZM166.239 77.9302C183.018 81.8177 207.674 86.7433 229.409 89.4141C240.695 90.801 251.114 91.5695 259.205 91.2894C263.256 91.1492 266.637 90.7484 269.216 90.0694C271.864 89.3724 273.323 88.471 273.971 87.6063C274.335 87.1218 274.427 86.6961 274.371 86.241C274.308 85.7182 274.024 84.995 273.321 84.0646C271.898 82.1791 269.171 79.9828 265.245 77.6165C257.455 72.9223 245.699 68.0005 232.706 63.7444C219.736 59.4954 205.654 55.9493 193.267 53.9664C187.073 52.9749 181.336 52.3797 176.393 52.2756C171.941 52.1818 168.245 52.4898 165.471 53.2033C166.081 55.8964 166.486 58.6718 166.712 61.5066C167.126 66.7089 166.935 72.127 166.276 77.6314C166.264 77.731 166.252 77.8306 166.239 77.9302ZM160.128 39.6984C159.383 38.4713 158.571 37.2799 157.687 36.1276C157.109 35.3735 156.525 34.6341 155.935 33.9092C132.06 4.55592 99.2608 -0.926261 85.2763 0.117508C70.6742 0.700915 46.4587 10.9381 19.7222 47.2702C-14.2926 93.4927 3.25449 137.376 16.4627 153.666C16.5218 153.739 16.5857 153.808 16.6539 153.872C42.8343 178.569 68.3689 183.93 89.5671 180.48C96.861 179.293 103.606 177.069 109.653 174.267C116.354 171.162 122.21 167.343 127.023 163.423C127.944 162.673 128.827 161.919 129.671 161.165C135.176 165.476 141.127 169.01 147.379 171.872C152.521 174.227 157.867 176.127 163.335 177.633C169.372 179.295 175.561 180.478 181.798 181.261C187.088 181.925 192.414 182.302 197.713 182.439C204.377 182.612 211.003 182.406 217.465 181.915C223.664 181.445 229.716 180.711 235.51 179.798C241.928 178.787 248.033 177.553 253.676 176.209C260.215 174.651 266.14 172.943 271.219 171.254C277.086 169.304 281.864 167.367 285.167 165.701C286.705 164.926 287.988 164.177 288.925 163.479C292.937 160.492 294.738 155.084 295.448 149.397C296.172 143.606 295.832 136.975 295.063 130.875C294.419 125.763 293.463 120.949 292.533 117.202C296.285 112.612 299.552 105.865 299.003 97.2362C300.67 94.5748 300.924 91.6006 300.451 88.8593C299.943 85.9114 298.583 83.1136 297.065 80.9077C296.977 80.7802 296.875 80.6627 296.762 80.5574C246.107 33.55 185.766 33.5061 160.128 39.6984ZM132.77 158.225C137.022 161.501 141.561 164.303 146.319 166.683C146.568 163.743 147.062 159.892 147.618 156.01C148.316 151.14 149.134 146.08 149.761 142.395C147.828 141.559 146.048 140.714 144.431 139.876C142.378 143.668 140.332 147.208 138.366 150.423C138.363 150.427 138.361 150.431 138.358 150.435C137.132 152.439 135.936 154.319 134.788 156.055C134.728 156.146 134.661 156.231 134.588 156.312C134.013 156.944 133.406 157.582 132.77 158.225ZM153.767 144.028C153.169 147.58 152.433 152.177 151.798 156.609C151.114 161.388 150.566 165.843 150.413 168.605C154.099 170.226 157.899 171.614 161.784 172.79V146.787C158.92 145.907 156.243 144.979 153.767 144.028ZM166.007 148.011V173.977C170.313 175.098 174.707 175.975 179.148 176.636C179.076 176.086 179.019 175.498 178.974 174.884C178.804 172.569 178.79 169.673 178.865 166.627C178.995 161.351 179.398 155.479 179.781 151.08C174.86 150.215 170.256 149.17 166.007 148.011ZM183.961 151.758C183.591 156.058 183.211 161.688 183.087 166.731C183.013 169.724 183.03 172.462 183.185 174.575C183.263 175.636 183.372 176.486 183.505 177.109C183.513 177.147 183.521 177.183 183.528 177.217C187.554 177.688 191.607 177.992 195.656 178.148V153.082C191.603 152.765 187.699 152.315 183.961 151.758ZM199.879 153.361V178.259C205.028 178.332 210.153 178.178 215.193 177.844V153.511C209.903 153.688 204.79 153.624 199.879 153.361ZM219.416 153.319V177.52C223.994 177.122 228.486 176.582 232.842 175.935L230.018 152.396C226.418 152.817 222.881 153.12 219.416 153.319ZM234.206 151.858L237.016 175.276C241.799 174.475 246.392 173.554 250.727 172.562L246.302 149.746C242.204 150.603 238.169 151.302 234.206 151.858ZM250.427 148.835L254.838 171.58C259.755 170.359 264.277 169.061 268.296 167.768L266.142 144.454C260.822 146.185 255.578 147.636 250.427 148.835ZM270.255 143.065L272.409 166.386C276.23 165.045 279.431 163.749 281.895 162.596L278.463 139.983C275.71 141.087 272.973 142.113 270.255 143.065ZM282.482 138.321L285.845 160.479C286.055 160.343 286.24 160.213 286.403 160.092C288.974 158.178 290.583 154.277 291.258 148.873C291.811 144.448 291.693 139.366 291.205 134.359C288.282 135.769 285.374 137.088 282.482 138.321ZM203.428 128.084C203.423 128.093 203.42 128.097 203.42 128.097C203.419 128.098 203.422 128.093 203.428 128.084ZM160.468 94.5735C160.482 94.576 160.491 94.5779 160.494 94.5786C160.498 94.5796 160.49 94.5784 160.468 94.5735ZM104.894 19.969C113.628 23.9166 121.114 31.745 122.738 45.7242C123.423 51.6268 124.145 56.2339 124.758 60.1457C124.997 61.6734 125.22 63.0952 125.417 64.4466C126.116 69.23 126.496 73.12 126.044 77.3939C125.152 85.8431 121.021 95.5195 110.669 117.112C102.043 135.105 87.9838 144.243 73.9801 148.314C60.0459 152.366 46.1398 151.418 37.5144 149.278C37.242 149.211 36.9858 149.089 36.7608 148.922C29.4465 143.469 20.0797 132.929 15.5502 118.871C10.989 104.714 11.3795 87.1145 23.4643 67.8314C35.3268 48.9029 47.1712 36.5044 57.2219 28.6933C67.1768 20.9567 75.4921 17.6312 80.3749 17.061C86.6885 15.9937 96.332 16.0992 104.894 19.969ZM103.155 23.817C95.5365 20.3737 86.7611 20.2545 81.0278 21.2333C80.9883 21.2401 80.9487 21.2457 80.909 21.2501C77.1003 21.6796 69.4816 24.5135 59.8132 32.0275C50.1992 39.4992 38.6756 51.5114 27.0424 70.0738C15.6316 88.2816 15.3836 104.584 19.5695 117.576C23.7164 130.446 32.2608 140.187 38.9453 145.28C46.996 147.198 59.9112 148.007 72.8012 144.26C85.8453 140.467 98.8358 132.026 106.861 115.287C117.323 93.4632 121.046 84.5165 121.845 76.9503C122.239 73.2166 121.925 69.7507 121.239 65.0571C121.05 63.7661 120.833 62.3809 120.598 60.8769C119.982 56.946 119.239 52.2036 118.543 46.2113C117.102 33.802 110.627 27.1943 103.155 23.817ZM75.1155 46.3049C85.5621 43.2847 96.0713 44.4702 102.624 46.5052C103.195 46.6826 103.664 47.0939 103.914 47.6369C104.165 48.1799 104.174 48.8036 103.938 49.3533L100.49 57.398C100.134 58.2283 99.2897 58.7402 98.389 58.6716C80.1743 57.283 69.5571 64.655 64.9691 70.1612H85.3971C86.5632 70.1612 87.5085 71.1065 87.5085 72.2726V79.5512C87.5085 80.7172 86.5632 81.6625 85.3971 81.6625H62.3702L60.0653 86.7614H85.3971C86.2018 86.7614 86.9366 87.2189 87.2917 87.941C87.972 89.3241 88.8487 91.5058 89.1168 93.4531C89.2453 94.3863 89.2871 95.6105 88.7866 96.6949C88.5146 97.2842 88.0758 97.8431 87.4261 98.2381C86.786 98.6272 86.0793 98.7735 85.3971 98.7735C84.0083 98.7735 79.0716 99.2437 73.2667 99.8629C68.786 100.341 63.9064 100.894 60.0202 101.346C63.3747 106.615 69.5076 107.808 75.7902 107.672C78.6213 107.61 81.2842 107.281 83.5489 107.002C84.1246 106.931 84.6745 106.863 85.195 106.803C86.3941 106.666 87.6079 106.551 88.5233 106.634C88.9373 106.672 89.6745 106.774 90.3127 107.242C90.6809 107.512 91.0294 107.915 91.2179 108.462C91.4015 108.996 91.3758 109.499 91.289 109.89C91.0572 110.933 90.453 112.107 89.8093 113.182C89.1332 114.311 88.2829 115.542 87.3923 116.748C85.6096 119.162 83.583 121.586 82.2543 123.089C81.9826 123.396 81.6273 123.617 81.2318 123.726C64.7538 128.254 54.148 125.016 47.8011 118.438C42.2959 112.733 40.3844 104.898 40.233 98.7735H32.1488C31.472 98.7735 30.8361 98.449 30.439 97.9009C30.0419 97.3528 29.9317 96.6475 30.1425 96.0043L32.6964 88.215C32.9807 87.3478 33.7901 86.7614 34.7027 86.7614H40.7536L42.1505 81.6625H34.7027C34.0308 81.6625 33.399 81.3427 33.0012 80.8012C32.6033 80.2597 32.487 79.5612 32.6879 78.92L36.0079 68.3214C36.3482 67.2351 37.4884 66.6141 38.5856 66.9176L48.8164 69.7474C54.9846 56.106 64.9863 49.2334 75.1155 46.3049ZM76.2884 50.3616C66.8787 53.082 57.5373 59.569 51.9784 73.0762C51.572 74.0637 50.4923 74.5923 49.4631 74.3076L39.4274 71.5318L37.5766 77.4398H44.9182C45.5767 77.4398 46.1975 77.747 46.5969 78.2705C46.9963 78.7941 47.1285 79.474 46.9545 80.1091L44.4007 89.4307C44.1493 90.3481 43.3155 90.9842 42.3643 90.9842H36.2324L35.0631 94.5507H42.3643C42.9412 94.5507 43.4929 94.7867 43.8913 95.2039C44.2897 95.6211 44.5 96.1831 44.4735 96.7593C44.2125 102.42 45.7342 110.214 50.8398 115.506C55.7266 120.57 64.3853 123.826 79.5054 119.818C80.7586 118.376 82.4783 116.294 83.9956 114.239C84.8428 113.092 85.6062 111.982 86.186 111.013C86.2012 110.988 86.2162 110.963 86.231 110.938C86.0572 110.956 85.8721 110.976 85.675 110.998C85.2127 111.051 84.7047 111.114 84.1582 111.182C81.8864 111.463 78.9511 111.827 75.8818 111.894C68.3431 112.057 58.7256 110.445 54.8245 100.361C54.5891 99.7524 54.6483 99.0692 54.9847 98.5102C55.3212 97.9512 55.8972 97.5792 56.5451 97.5024C60.6793 97.0122 67.0726 96.277 72.8188 95.664C78.074 95.1034 82.9594 94.625 84.9774 94.5586C84.9754 94.4246 84.964 94.2501 84.9335 94.0291C84.8075 93.1135 84.4442 91.9916 84.0317 90.9842H56.7937C56.0766 90.9842 55.4085 90.6202 55.0197 90.0177C54.6308 89.4152 54.5744 88.6565 54.8698 88.0031L59.0837 78.6814C59.4254 77.9255 60.1781 77.4398 61.0076 77.4398H83.2857V74.384H61.0076C60.2737 74.384 59.5924 74.0029 59.2084 73.3775C58.8243 72.7521 58.7926 71.9722 59.1245 71.3176C62.4717 64.7175 74.5691 53.1737 97.1965 54.3635L99.1018 49.9178C93.1525 48.4949 84.6647 47.9399 76.2884 50.3616ZM88.2427 110.854C88.2421 110.854 88.231 110.853 88.2114 110.848C88.2336 110.851 88.2434 110.853 88.2427 110.854Z"
								fill="#0F393B"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M170.844 58.0273C171.151 57.8616 171.495 57.7749 171.845 57.7749H183.592C184.71 57.7749 185.635 58.6463 185.7 59.7623C185.738 60.4123 186.055 61.1128 186.803 61.88C187.561 62.6585 188.665 63.399 190.01 64.0672C192.095 65.103 194.518 65.8469 196.508 66.2969L198.384 61.9814C198.82 60.9782 199.95 60.4743 200.988 60.8202L206.734 62.7356C207.809 63.0938 208.409 64.2363 208.095 65.3246L207.214 68.3735H210.546L213.014 63.7451C213.381 63.057 214.098 62.6273 214.877 62.6273H219.985C221.151 62.6273 222.097 63.5726 222.097 64.7386V69.7781H241.693C242.233 69.7781 242.753 69.9852 243.145 70.3567L247.998 74.9537C248.436 75.3689 248.675 75.9518 248.656 76.5552C248.636 77.1586 248.359 77.7247 247.895 78.1105C243.95 81.3873 237.873 82.166 232.392 82.0547C227.715 81.9597 223.059 81.2036 219.638 80.4023L219.153 81.6971C218.844 82.5212 218.056 83.0671 217.176 83.0671H210.28C209.207 83.0671 208.305 82.2619 208.183 81.1955L207.886 78.5978H206.518V79.5511C206.518 80.7172 205.573 81.6625 204.407 81.6625H197.766C196.6 81.6625 195.655 80.7172 195.655 79.5511V79.0282C194.259 79.0676 192.796 78.833 191.384 78.4753C188.844 77.8314 186.062 76.6796 183.338 75.3296C177.882 72.6254 172.36 68.9765 168.928 66.4354C168.39 66.0373 168.073 65.4078 168.073 64.7386C168.073 62.9122 168.392 61.4739 168.877 60.3808C169.333 59.3513 170.01 58.4759 170.844 58.0273ZM199.878 77.4397H202.295V76.4865C202.295 75.3204 203.24 74.3751 204.407 74.3751H209.77C210.843 74.3751 211.746 75.1803 211.867 76.2467L212.164 78.8444H215.713L216.348 77.1497C216.732 76.1266 217.833 75.5653 218.886 75.8556C222.072 76.7337 227.291 77.7274 232.478 77.8328C236.61 77.9168 240.381 77.4274 243.121 76.1506L240.852 74.0009H219.985C218.819 74.0009 217.874 73.0556 217.874 71.8895V66.85H216.144L213.676 71.4784C213.309 72.1665 212.593 72.5962 211.813 72.5962H204.407C203.743 72.5962 203.118 72.2842 202.719 71.7538C202.32 71.2235 202.194 70.5364 202.378 69.8989L203.475 66.1005L201.486 65.4374L199.703 69.539C199.316 70.4275 198.375 70.9391 197.419 70.7798C194.983 70.3737 191.301 69.4238 188.131 67.8491C186.546 67.0616 184.987 66.0686 183.777 64.8263C182.999 64.0269 182.328 63.0834 181.914 61.9977H172.781C172.767 62.027 172.752 62.0586 172.737 62.0924C172.59 62.425 172.429 62.9464 172.348 63.7033C175.66 66.0849 180.493 69.2064 185.213 71.546C187.803 72.8296 190.286 73.8407 192.422 74.3819C194.638 74.9437 196.109 74.9018 196.931 74.5475C197.583 74.2663 198.333 74.3321 198.927 74.7226C199.52 75.1131 199.878 75.776 199.878 76.4865V77.4397Z"
								fill="#0F393B"
							/>
						</svg>
					</div>
				</div>
			</div>
		</section>
		<!--end-->

		<!--package-->
		<section class="package">
			<div class="container eleven80">
				<div class="mobileshow">
					<div class="row">
						<div class="col-md-12 mprices">
							<div class="price_switch text-center">
								<ul>
									<li class="monthly">Monthly</li>
									<li class="checkboxsc">
										<b-form-checkbox
											v-model="moyrok"
											name="check-button"
											switch
										>
											<span>Annual (2 months free)</span>
										</b-form-checkbox>
									</li>
								</ul>
							</div>
							<div class="scrollrightleft">
								<svg
									width="21"
									height="12"
									viewBox="0 0 21 12"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0.469669 5.46967C0.176777 5.76256 0.176777 6.23744 0.469669 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46446 6.59619 0.989591 6.3033 0.696698C6.01041 0.403804 5.53553 0.403804 5.24264 0.696698L0.469669 5.46967ZM21 5.25L1 5.25L1 6.75L21 6.75L21 5.25Z"
										fill="#CED9D2"
									/>
								</svg>
								<span>Scroll for more plans</span>
							</div>
							<carousel :autoplay="false" :nav="false" :items="1">
								<!--p-1-->
								<div class="pricebox scprice basicsc">
									<h3 class="titlepackage">Basic</h3>
									<ul class="titlepackage">
										<li>Key features</li>
										<li class="rightsc">
											<svg
												width="65"
												height="9"
												viewBox="0 0 65 9"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<rect width="9" height="9" rx="2" fill="#EF8451" />
												<rect
													x="14"
													width="9"
													height="9"
													rx="2"
													fill="#EF8451"
												/>
												<rect
													x="28.5"
													y="0.5"
													width="8"
													height="8"
													rx="1.5"
													stroke="#CED9D2"
												/>
												<rect
													x="42.5"
													y="0.5"
													width="8"
													height="8"
													rx="1.5"
													stroke="#CED9D2"
												/>
												<rect
													x="56.5"
													y="0.5"
													width="8"
													height="8"
													rx="1.5"
													stroke="#CED9D2"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>SEO Audit</li>
										<li class="rightsc">50 pages</li>
									</ul>
									<ul>
										<li>Keyword Research</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M12.3309 7.65967L7.66846 12.3222"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													d="M12.3309 12.3251L7.66455 7.65771"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Content Marketing</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M12.3309 7.65967L7.66846 12.3222"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													d="M12.3309 12.3251L7.66455 7.65771"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Competitor Analysis</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M12.3309 7.65967L7.66846 12.3222"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													d="M12.3309 12.3251L7.66455 7.65771"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Backlink</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M12.3309 7.65967L7.66846 12.3222"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													d="M12.3309 12.3251L7.66455 7.65771"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Marketing Automation</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M12.3309 7.65967L7.66846 12.3222"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													d="M12.3309 12.3251L7.66455 7.65771"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
													stroke="#CED9D2"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul class="packagebtn">
										<li>
											<h3 v-if="moyrok">€999 <span>.95 /Yer</span></h3>
											<h3 v-else>€89 <span>.95 /mo</span></h3>
										</li>
									</ul>
									<div class="text-center">
										<router-link to="#" class="callbtn"
											>Start free trial</router-link
										>
									</div>
								</div>

								<!--end-->
								<!--p-2-->
								<div class="pricebox scprice">
									<h3 class="titlepackage">Pro</h3>
									<ul class="titlepackage">
										<li>Key features</li>
										<li class="rightsc">
											<svg
												width="65"
												height="9"
												viewBox="0 0 65 9"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<rect width="9" height="9" rx="2" fill="#EF8451" />
												<rect
													x="14"
													width="9"
													height="9"
													rx="2"
													fill="#EF8451"
												/>
												<rect
													x="28"
													width="9"
													height="9"
													rx="2"
													fill="#EF8451"
												/>
												<rect
													x="42"
													width="9"
													height="9"
													rx="2"
													fill="#EF8451"
												/>
												<rect
													x="56.5"
													y="0.5"
													width="8"
													height="8"
													rx="1.5"
													stroke="#CED9D2"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>SEO Audit</li>
										<li class="rightsc">500 pages</li>
									</ul>
									<ul>
										<li>Keyword Research</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Content Marketing</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Competitor Analysis</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Backlink</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Marketing Automation</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul class="packagebtn">
										<li>
											<h3 v-if="moyrok">€1974 <span>.95 /Yer</span></h3>
											<h3 v-else>€174 <span>.95 /mo</span></h3>
										</li>
									</ul>
									<div class="text-center">
										<router-link to="#" class="callbtn"
											>Start free trial</router-link
										>
									</div>
								</div>

								<!--end-->
								<!--p-3-->
								<div class="pricebox scprice">
									<h3 class="titlepackage">Enterprise</h3>
									<ul class="titlepackage">
										<li>Key features</li>
										<li class="rightsc">
											<svg
												width="65"
												height="9"
												viewBox="0 0 65 9"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<rect width="9" height="9" rx="2" fill="#EF8451" />
												<rect
													x="14"
													width="9"
													height="9"
													rx="2"
													fill="#EF8451"
												/>
												<rect
													x="28"
													width="9"
													height="9"
													rx="2"
													fill="#EF8451"
												/>
												<rect
													x="42"
													width="9"
													height="9"
													rx="2"
													fill="#EF8451"
												/>
												<rect
													x="56"
													width="9"
													height="9"
													rx="2"
													fill="#EF8451"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>SEO Audit</li>
										<li class="rightsc">Unlimited</li>
									</ul>
									<ul>
										<li>Keyword Research</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Content Marketing</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Competitor Analysis</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Backlink</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul>
										<li>Marketing Automation</li>
										<li class="rightsc">
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7483 0H4.25081C1.63805 0 0 1.84995 0 4.46789V11.5321C0 14.1501 1.63027 16 4.25081 16H11.7475C14.3689 16 16 14.1501 16 11.5321V4.46789C16 1.84995 14.3689 0 11.7483 0Z"
													fill="#0F393B"
												/>
												<path
													d="M4.91992 8.00057L6.97311 10.0529L11.0778 5.94824"
													stroke="#F5F3EE"
													stroke-width="1.33333"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</li>
									</ul>
									<ul class="packagebtn">
										<li>
											<h3 v-if="moyrok">€3099 <span>.95 /Yer</span></h3>
											<h3 v-else>€499 <span>.95 /mo</span></h3>
										</li>
									</ul>
									<div class="text-center">
										<router-link to="#" class="callbtn">Subscribe</router-link>
									</div>
								</div>

								<!--end-->
							</carousel>
						</div>
					</div>
				</div>

				<div class="row laptopshow">
					<div class="col-md-12">
						<div class="price_switch text-center">
							<ul>
								<li class="monthly">Monthly Pricing</li>
								<li class="checkboxsc">
									<b-form-checkbox v-model="checked" name="check-button" switch>
										<span>Annual Pricing (2 months free)</span>
									</b-form-checkbox>
								</li>
							</ul>
						</div>
						<div class="packagecontent scprice">
							<ul class="titlepackage">
								<li>&nbsp;</li>
								<li>Basic</li>
								<li>Pro</li>
								<li>Enterprise</li>
							</ul>
							<ul class="mainkey">
								<li>Key features</li>
								<li>
									<svg
										width="65"
										height="9"
										viewBox="0 0 65 9"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<rect width="9" height="9" rx="2" fill="#EF8451" />
										<rect x="14" width="9" height="9" rx="2" fill="#EF8451" />
										<rect
											x="28.5"
											y="0.5"
											width="8"
											height="8"
											rx="1.5"
											stroke="#CED9D2"
										/>
										<rect
											x="42.5"
											y="0.5"
											width="8"
											height="8"
											rx="1.5"
											stroke="#CED9D2"
										/>
										<rect
											x="56.5"
											y="0.5"
											width="8"
											height="8"
											rx="1.5"
											stroke="#CED9D2"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="65"
										height="9"
										viewBox="0 0 65 9"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<rect width="9" height="9" rx="2" fill="#EF8451" />
										<rect x="14" width="9" height="9" rx="2" fill="#EF8451" />
										<rect x="28" width="9" height="9" rx="2" fill="#EF8451" />
										<rect x="42" width="9" height="9" rx="2" fill="#EF8451" />
										<rect
											x="56.5"
											y="0.5"
											width="8"
											height="8"
											rx="1.5"
											stroke="#CED9D2"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="65"
										height="9"
										viewBox="0 0 65 9"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<rect width="9" height="9" rx="2" fill="#EF8451" />
										<rect x="14" width="9" height="9" rx="2" fill="#EF8451" />
										<rect x="28" width="9" height="9" rx="2" fill="#EF8451" />
										<rect x="42" width="9" height="9" rx="2" fill="#EF8451" />
										<rect x="56" width="9" height="9" rx="2" fill="#EF8451" />
									</svg>
								</li>
							</ul>
							<ul class="itemlist">
								<li>SEO Audit</li>
								<li>50 pages</li>
								<li>500 pages</li>
								<li>Unlimited</li>
							</ul>
							<ul class="itemlist">
								<li>Keyword Research</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
							</ul>
							<ul class="itemlist">
								<li>Content Marketing</li>
								<li>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12.3309 7.65967L7.66846 12.3222"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M12.3309 12.3251L7.66455 7.65771"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
							</ul>
							<ul class="itemlist">
								<li>Competitor Analysis</li>
								<li>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12.3309 7.65967L7.66846 12.3222"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M12.3309 12.3251L7.66455 7.65771"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
							</ul>
							<ul class="itemlist">
								<li>Backlink</li>
								<li>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12.3309 7.65967L7.66846 12.3222"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M12.3309 12.3251L7.66455 7.65771"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
							</ul>
							<ul class="itemlist">
								<li>Marketing Automation</li>
								<li>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12.3309 7.65967L7.66846 12.3222"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M12.3309 12.3251L7.66455 7.65771"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M14.2169 1H5.78216C2.84281 1 1 3.08119 1 6.02638V13.9736C1 16.9188 2.83405 19 5.78216 19H14.2159C17.165 19 19 16.9188 19 13.9736V6.02638C19 3.08119 17.165 1 14.2169 1Z"
											stroke="#CED9D2"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
								<li>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.2169 0H4.78216C1.84281 0 0 2.08119 0 5.02638V12.9736C0 15.9188 1.83405 18 4.78216 18H13.2159C16.165 18 18 15.9188 18 12.9736V5.02638C18 2.08119 16.165 0 13.2169 0Z"
											fill="#0F393B"
										/>
										<path
											d="M5.53613 8.99978L7.84597 11.3086L12.4637 6.69092"
											stroke="#F5F3EE"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</li>
							</ul>
							<ul class="packagebtn">
								<li>&nbsp;</li>
								<li>
									<h3 v-if="checked">€999 <span>.95 /Yer</span></h3>
									<h3 v-else>€89 <span>.95 /mo</span></h3>
									<div>
										<router-link to="#" class="callbtn"
											>Try for free</router-link
										>
									</div>
									<div>
										or
										<router-link to="#" class="subsc"> subscribe</router-link>
									</div>
								</li>
								<li>
									<h3 v-if="checked">€1974 <span>.95 /Yer</span></h3>
									<h3 v-else>€174 <span>.95 /mo</span></h3>
									<div>
										<router-link to="#" class="callbtn"
											>Try for free</router-link
										>
									</div>
									<div>
										or
										<router-link to="#" class="subsc"> subscribe</router-link>
									</div>
								</li>
								<li>
									<h3 v-if="checked">€3099 <span>.95 /Yer</span></h3>
									<h3 v-else>€499 <span>.95 /mo</span></h3>
									<div>
										<router-link to="#" class="callbtn">Subscribe</router-link>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!--end-->

		<!--price call-->
		<section class="price_callaction">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<h3>Test our tools now, make your choice later</h3>
						<a
							:href="`https://my.seosuite.io/${$i18n.locale}/signup`"
							target="_blank"
							class="callbtn2"
							>Start your free trial</a
						>
					</div>
				</div>
			</div>
		</section>
		<!--end-->
	</div>
</template>

<script>
	import MainPage from "@/layouts/MainPage.vue";
	import carousel from "vue-owl-carousel";
	export default {
		data: () => ({
			//for laptop switch
			checked: false,
			//for mobile switch
			moyrok: false,
		}),
		components: {
			carousel,
		},

		//this for layout call
		created() {
			this.$parent.$emit("update:layout", MainPage);
		},
		//this for layout render
		render() {
			return this.$slots.default[0];
		},
		//Meta info title + description + others meta
		metaInfo() {
			return {
				title: "SEO Suite",
				htmlAttrs: {
					lang: this.$i18n.locale,
				},
				meta: [
					{ name: "description", content: "SEO Suite" },
					{ property: "og:title", content: "SEO Suite" },
					{ property: "og:site_name", content: "SEO Suite" },
					{ property: "og:type", content: "website" },
					{ name: "robots", content: "index,follow" },
				],
			};
		},
		//end meta info
	};
</script>

<style lang="scss" scoped></style>
